import { IllustrationError, Text } from '@bbl-digital/snorre-v2'

type ErrorContentProps = {
  /** Error message to display. Default is shown if not provided */
  text?: string
}

const ErrorContent = ({ text = 'En feil har oppstått' }: ErrorContentProps) => {
  {
    return (
      <li className="flex flex-col justify-center items-center mb-4">
        <div className="flex justify-center items-center">
          <IllustrationError className="w-[250px] h-[200px]" />
        </div>
        <Text className="text-ui-errorDark" weight="bold">
          {text}
        </Text>
      </li>
    )
  }
}

export default ErrorContent
